import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosRequest } from '@/util/axios-request';
import datePicker from '_c/date-picker';
import { util } from '@/util/util';
import { listFn, exportFn as _exportFn, configFn } from 'api/approval/search';
import seeComp from './see';
import { sysInfoFn as _sysInfoFn } from 'api/org/per';
import ExportMore from './modal/export';
var defaultDate = [util.fmtDate('yyyy-MM-dd', util.getTime(-90)), util.fmtDate('yyyy-MM-dd', util.getTime(0))];
export default {
  components: {
    datePicker: datePicker,
    seeComp: seeComp,
    ExportMore: ExportMore
  },
  data: function data() {
    return {
      exportLoading: false,
      completeDate: [],
      actualOccurrence: [],
      // 实际发生时间
      dataForm: {
        staff_state: '',
        // 在职状态
        create_date_start: '',
        create_date_end: '',
        finish_date_start: '',
        finish_date_end: '',
        audit_type: [] // 审批类型
      },

      typeArr: [],
      stateArr: [],
      // 在职状态
      onJobStates: [],
      pageSizes: [100, 50, 20],
      sort: '',
      dir: '',
      page: {
        list: [{}],
        currPage: 1,
        limit: 100,
        total: 0
      },
      chooseRange: 90,
      defaultDate: defaultDate,
      tableLoading: false,
      isSeeComp: false,
      // 作废业务相关数据
      disuse: {
        // 作废提交loading
        submitLoading: false,
        // 作废Dialog是否显示
        dialogVisible: false,
        // 作废相关提交参数
        payload: {
          audit_type: '',
          audit_id: '',
          disuse_reason: ''
        }
      }
    };
  },
  watch: {
    'disuse.dialogVisible': function disuseDialogVisible(visible) {
      if (!visible) {
        this.disuse.payload = {
          audit_type: '',
          audit_id: '',
          disuse_reason: ''
        };
      }
    }
  },
  mounted: function mounted() {
    ;
    var _this$defaultDate = _slicedToArray(this.defaultDate, 2);
    this.dataForm.create_date_start = _this$defaultDate[0];
    this.dataForm.create_date_end = _this$defaultDate[1];
    this.getConfigFn();
    // 获取选项值
    this.sysInfoFn();
  },
  methods: {
    openDisuseDialog: function openDisuseDialog(row) {
      this.disuse.dialogVisible = true;
      this.disuse.payload.audit_type = row.type;
      this.disuse.payload.audit_id = row.audit_id;
    },
    // 导出查询结果
    exportSearchFn: function exportSearchFn() {
      this.$refs.more.init();
    },
    // 作废处理
    handleDisuse: function handleDisuse(data) {
      var _this = this;
      this.disuse.submitLoading = true;
      axiosRequest({
        url: '/web/approval/disuse',
        method: 'POST',
        data: data
      }).then(function (res) {
        if (res.code === 1) {
          _this.disuse.dialogVisible = false;
          _this.$message.success(_this.$t('disuse_success'));
          _this.getTableList();
        }
      }).catch(function (err) {
        throw err;
      }).finally(function () {
        _this.disuse.submitLoading = false;
      });
    },
    // 获取在职状态
    sysInfoFn: function sysInfoFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context.sent;
              _this2.onJobStates = res.data.state;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 排序
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.sort = prop;
      this.dir = order;
      this.getTableList();
    },
    getConfigFn: function getConfigFn() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return configFn();
            case 2:
              res = _context2.sent;
              if (res && res.code === 1) {
                _this3.typeArr = res.data.audit_type.map(function (v) {
                  return {
                    label: v.value,
                    value: v.code
                  };
                });
                _this3.stateArr = res.data.state;
                _this3.getTableList();
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getTableList: function getTableList() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // loading 表格
              _this4.tableLoading = true;
              listFn(_objectSpread(_objectSpread({}, _this4.dataForm), {}, {
                sort: _this4.sort,
                // 排序相关
                dir: _this4.dir,
                page_num: _this4.page.currPage,
                page_count: _this4.page.limit,
                finish_date_start: _this4.completeDate ? _this4.completeDate[0] : '',
                finish_date_end: _this4.completeDate ? _this4.completeDate[1] : '',
                actual_date_start: _this4.actualOccurrence ? _this4.actualOccurrence[0] : '',
                actual_date_end: _this4.actualOccurrence ? _this4.actualOccurrence[1] : ''
              })).then(function (res) {
                _this4.page.list = res.data.dataList;
                _this4.page.total = res.data.pagination.total;
              }).finally(function () {
                return _this4.tableLoading = false;
              });
              // this.$nextTick(() => this.$refs.table.doLayout && this.$refs.table.doLayout())
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    dataPickerSuccess: function dataPickerSuccess(val) {
      ;
      var _ref2 = val || ['', ''];
      var _ref3 = _slicedToArray(_ref2, 2);
      this.dataForm.create_date_start = _ref3[0];
      this.dataForm.create_date_end = _ref3[1];
    },
    // 每页条数
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.page.limit = val;
      this.getTableList();
    },
    // 切换 页
    currentChangeHandle: function currentChangeHandle(val) {
      this.page.currPage = val;
      this.getTableList();
    },
    exportFn: function exportFn() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.exportLoading = true;
              _context4.next = 3;
              return _exportFn(_objectSpread(_objectSpread({}, _this5.dataForm), {}, {
                finish_date_start: _this5.completeDate ? _this5.completeDate[0] : '',
                finish_date_end: _this5.completeDate ? _this5.completeDate[1] : '',
                actual_date_start: _this5.actualOccurrence ? _this5.actualOccurrence[0] : '',
                actual_date_end: _this5.actualOccurrence ? _this5.actualOccurrence[1] : ''
              })).finally(function () {
                return _this5.exportLoading = false;
              });
            case 3:
              res = _context4.sent;
              if (res && res.code === 1) window.open(res.data.object_url);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    seeFn: function seeFn(item) {
      var _this6 = this;
      this.isSeeComp = true;
      this.$nextTick(function () {
        _this6.$refs.seeComp.init(item);
      });
    },
    // 数据初始化
    clearAuditType: function clearAuditType() {
      this.actualOccurrence = [];
    }
  }
};